export default "__VITE_ASSET__DwqbTmH7__"